import discount from '../../fields/shared/discount';

export const QUERY_GET_ALL_DISCOUNTS = /* GraphQL */ `
	query($filter: DiscountFilter) {
		getAllDiscount(filter: $filter) {
			${discount}
		}
	}
`;
